<span class="badge badge-secondary" [innerText]="this.backendService.notes.length">0</span>
